import {
  API_URL,
  RESIDENT_WOUND_DRESSING_OPTION,
  ROUTES,
} from "../../../constants";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { EntityManagement } from "../../../components";
import {
  WoundDressingsForm,
  initialValues,
  validationSchema,
} from "./form/WoundDressingsForm";
import { PageHeader } from "../../../components/PageHeader";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const WoundDressingsPageHeader = (props) => {
  const { setCreating, clearNotification } = props;

  return (
    <PageHeader title="傷口敷料">
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleOutlinedIcon />}
        onClick={() => {
          clearNotification();
          setCreating(true);
        }}
      >
        新增傷口敷料
      </Button>
    </PageHeader>
  );
};

export default function WoundDressings() {
  const home = useSelector((state) => state.home);
  const [apiUrl, setApiUrl] = useState({});

  const createParams = (values, coreCreateParams) => {
    let params = {};
    params = coreCreateParams(values);

    return params;
  };

  const getColumnSettings = (props) => {
    const {
      setEditingEntity,
      setDeletingEntity,
      setCopyEntity,
      clearNotification,
      loading,
    } = props;

    return [
      {
        field: "action",
        headerName: "動作",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <div>
              <Tooltip title="修改">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setEditingEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="刪除">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setDeletingEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <DeleteOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="另存">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setCopyEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <FileCopyOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        field: "name",
        headerName: "傷口敷料名稱",
        width: 500,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row[params.field];
        },
      },
      {
        field: "type",
        headerName: "傷口敷料類別",
        width: 500,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return RESIDENT_WOUND_DRESSING_OPTION.find(
            (elem) => elem.value == params.row[params.field]
          )?.label;
        },
      },
    ];
  };

  useEffect(() => {
    setApiUrl({
      getAll: API_URL.NURSING_WOUND_DRESSINGS,
      getOne: API_URL.NURSING_WOUND_DRESSINGS,
      create: API_URL.NURSING_WOUND_DRESSINGS,
      edit: API_URL.NURSING_WOUND_DRESSINGS,
      delete: API_URL.NURSING_WOUND_DRESSINGS,
      copy: API_URL.NURSING_WOUND_DRESSINGS,
    });
  }, [home]);

  return (
    <EntityManagement
      entityModel="傷口敷料"
      editableFields={["name", "type"]}
      getColumnSettings={getColumnSettings}
      createParams={createParams}
      apiUrl={apiUrl}
      dataInputForm={WoundDressingsForm}
      initialValues={initialValues}
      validationSchema={validationSchema}
      maxWidth="sm"
      pageHeader={WoundDressingsPageHeader}
    ></EntityManagement>
  );
}
